export interface IRequestUpdateModel {
    id?: string;
    remarks: string;
    request_source: string;
    external_reference_no: string;
    old_booking_number: string;
    master_agreement_no:string;
    master_agreement_valid_till:string;
    sales_person:string;
    operations_user:string;
    billing_entity:string;
}

export interface RequestUpdateError {
    remarks: string[];
    request_source: string[];
    external_reference_no: string[];
    old_booking_number: string[];
    sales_person: string[];
    operations_user: string[];
    billing_entity: [];

}

export class RequestUpdateModel {
    remarks: string;
    request_source: string;
    external_reference_no: string;
    old_booking_number: string;
    master_agreement_no:string;
    master_agreement_valid_till:string;
    sales_person:any;
    operations_user:any;
    billing_entity:any;
    error: RequestUpdateError;

    constructor() {
        this.remarks = null;
        this.request_source = null;
        this.external_reference_no = null;
        this.old_booking_number = null;
        this.sales_person = null;
        this.operations_user = null;
        this.billing_entity = null;

        this.resetErrors();
    }

    resetErrors() {
        this.error = {
            remarks: [],
            request_source: [],
            external_reference_no: [],
            old_booking_number: [],
            sales_person: [],
            operations_user:[],
            billing_entity:[]
        }
    }

    setRequestPayloadToModel(data) {
        this.remarks = data.remarks;
        this.request_source = data.request_source;
        this.external_reference_no = data.external_reference_no;
        this.old_booking_number = data.old_booking_number;
        this.master_agreement_no = data.master_agreement_no;
        this.master_agreement_valid_till = data.master_agreement_valid_till;
        this.sales_person = data.sales_person;
        this.operations_user = data.operations_user;
        this.billing_entity = data.billing_entity;


    }

    getRequestData(): IRequestUpdateModel {
        return {
            remarks: this.remarks,
            request_source: this.request_source,
            external_reference_no: this.external_reference_no,
            old_booking_number: this.old_booking_number,
            master_agreement_no:this.master_agreement_no,
            master_agreement_valid_till:this.master_agreement_valid_till,
            // sales_person:this.sales_person?.id,
            // operations_user:this.operations_user?.id,
            sales_person : typeof this.sales_person == 'object' && this.sales_person != null ? this.sales_person.id : this.sales_person,
            operations_user : typeof this.operations_user == 'object' && this.operations_user != null ? this.operations_user.id : this.operations_user,
            billing_entity : typeof this.billing_entity == 'object' && this.billing_entity != null ? this.billing_entity.id : this.billing_entity,
        }
    }
}